<script setup lang="ts">
import type { EsFilterDefaultFragment } from '#graphql-operations'

type FilterOption = NonNullable<NonNullable<EsFilterDefaultFragment['options']>[number]>

export type Props = {
  option: FilterOption
  filter: Pick<EsFilterDefaultFragment, 'key' | 'hasUrl' | 'type'>
}

const props = defineProps<Props>()
defineEmits(['option-toggle'])

const label = computed(() => {
  return props.option.label
})

const { public: config } = useRuntimeConfig()

function swatchBg(option: FilterOption) {
  if (option.swatch?.startsWith('#')) {
    return {
      backgroundColor: option.swatch,
    }
  }

  if (option.swatch) {
    const swatchPath = config.baseDomain + '/media/attribute/swatch'
    return {
      backgroundImage: `url('${swatchPath + option.swatch}')`,
    }
  }
}
</script>

<template>
  <li class="filter-option">
    <a
      v-if="filter.hasUrl && option.urlPath"
      :href="option.urlPath + '/'"
      class="filter-option__link"
      :class="{ 'filter-option__link--active': option.toBeSelected }"
      @click.prevent="$emit('option-toggle', option.key)"
    >
      <span
        class="filter-option__input checkbox"
        :class="{ 'checkbox--checked': option.selected }"
      />

      <span class="filter-option__label">
        <span
          v-if="filter.type === 'visual'"
          class="filter-option__swatch"
          :style="swatchBg(option)"
        />
        <span class="filter-option__text">
          <span class="filter-option__name">{{ label }}</span><!-- This data comes from Magento, can we try to fix the translation there? -->
          <span class="filter-option__count">{{ option.count }}</span>
        </span>
      </span>
    </a>
    <template v-else>
      <input
        :id="`filter-${filter.key}-${option.key}`"
        type="checkbox"
        class="filter-option__input"
        :checked="option.selected"
        @input="$emit('option-toggle', option.key)"
      >
      <label
        class="filter-option__label"
        :for="`filter-${filter.key}-${option.key}`"
      >
        <span
          v-if="filter.type === 'visual'"
          class="filter-option__swatch"
          :style="swatchBg(option)"
        />
        <span class="filter-option__text">
          <span class="filter-option__name">{{ label }}</span>
          <span class="filter-option__count">{{ option.count }}</span>
        </span>
      </label>
    </template>
  </li>
</template>

<style>
@import url("~layers/components/Filter/Option.css");
</style>
